import client from 'api/client';
import { AxiosResponse } from 'axios';

export function get(userID?: number, country?: string): Promise<AxiosResponse> {
    let path = `program-list`;
    if (userID !== null || country !== null) {
        path += `?`;
    }
    if (userID) {
        path += `client_id=${userID}&`;
    }
    if (country) {
        path += `country=${country}&`;
    }
    return client.get(path);
}
